import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { authStoreStateSelector } from '~/selectors';

export const useIsAuthenticated = () => {
  return useSelector<StoreState, boolean>((state) => {
    return !!authStoreStateSelector(state).userDetails;
  });
};
